import { NotificationEventType } from "../../src/domain/notification/Models/NotificationEventType"

export default {
  title: "Notificaciones",
  empty: "No tienes notificaciones por ver",
  loadMore: "Cargar más",
  markAllRead: "Marcar como leídos",
  markAllReadModal: {
    title: "Marcar como leídos",
    message: "¿Estas seguro que quieres marcarlos como leídos, una vez lo hagas desaparecerán las notificaciones?",
    confirm: "SI, CONTINUAR",
  },
  eventTitle: {
    [NotificationEventType.VOTING_CREATED]: "Nueva votación programada",
    [NotificationEventType.VOTING_CLOSING_SOON]: "Votación próxima a cerrar",
    [NotificationEventType.VOTING_RESULT]: "Votación finalizada",
    [NotificationEventType.VOTE_CONFIRMED]: "Voto confirmado",
    [NotificationEventType.SUBSCRIPTION_RENEWED]: "Suscripción renovada",
    [NotificationEventType.SUBSCRIPTION_FAILED]: "Fallo en suscripción",
    [NotificationEventType.SUBSCRIPTION_EXPIRED]: "Suscripción expirada",
    [NotificationEventType.SUBSCRIPTION_CANCELLED]: "Suscripción cancelada",
    [NotificationEventType.KYC_APPROVED]: "Verificación aprobada",
    [NotificationEventType.KYC_REJECTED]: "Verificación rechazada",
  },
  preferences: {
    subtitle: "Configura las notificaciones a tu gusto",
    inApp: {
      title: "Notificaciones in-app",
    },
    email: {
      title: "Notificaciones via email",
      label: "Tu email",
    },
    eventLabel: {
      [NotificationEventType.VOTING_CREATED]: "Nueva votación programada",
      [NotificationEventType.VOTING_CLOSING_SOON]: "Votación próxima a cerrar",
      [NotificationEventType.VOTING_RESULT]: "Votación finalizada (todas)",
      [NotificationEventType.VOTE_CONFIRMED]: "Votación finalizada (votada)",
    },
  },
  eventDescription: {
    [NotificationEventType.VOTING_CREATED]: 'Consulta la nueva votación "{{title}}"',
    [NotificationEventType.VOTING_CLOSING_SOON]: 'La votación "{{title}}" está próxima a cerrar',
    [NotificationEventType.VOTING_RESULT]: 'Consulta el resultado de la votación en la que has participado "{{title}}"',
    [NotificationEventType.VOTE_CONFIRMED]: 'Tu voto en "{{title}}" ha sido confirmado',
    [NotificationEventType.SUBSCRIPTION_RENEWED]: "Tu suscripción se ha renovado correctamente",
    [NotificationEventType.SUBSCRIPTION_FAILED]: "Ha fallado el pago de tu suscripción",
    [NotificationEventType.SUBSCRIPTION_EXPIRED]: "Tu suscripción ha expirado",
    [NotificationEventType.SUBSCRIPTION_CANCELLED]: "Tu suscripción ha sido cancelada",
    [NotificationEventType.KYC_APPROVED]: "Tu verificación de identidad ha sido aprobada",
    [NotificationEventType.KYC_REJECTED]: "Tu verificación de identidad ha sido rechazada",
  },
}
